import script from "./PostRelease.vue?vue&type=script&setup=true&lang=js"
export * from "./PostRelease.vue?vue&type=script&setup=true&lang=js"

import "./PostRelease.vue?vue&type=style&index=0&id=11ec314e&lang=scss"

const __exports__ = script;

export default __exports__